import { render, staticRenderFns } from "./directories.vue?vue&type=template&id=5cb828ce"
import script from "./directories.vue?vue&type=script&lang=ts"
export * from "./directories.vue?vue&type=script&lang=ts"
import style0 from "./directories.vue?vue&type=style&index=0&id=5cb828ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports